import React from "react";
import {
    BrowserRouter,
} from "react-router-dom";
import RootRouter from './routes'
import configureStore from './Store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
const theme = createTheme({
    palette: {
        primary: {
            light: '#a3c3ce',
            main: '#216e8a',
            dark: '#005979',
            contrastText: '#fff',
        },
        secondary: {
            light: '#68d26f',
            main: '#00a950',
            dark: '#00a950',
        },
        text: {
            primary: '#666',
        },
        background: {
            default: '#f2f2f2',
            container: '#F5F6FA',
            light: '#ffffff',
            secondaryLight: '#F4F5F9',
            main: '#fafafa',
            dark: '#9fa1a3',
            footer: '#3B3C42',
            lightBlue: '#13B6E5',
        },
        input: {
            active: '#dbdbdb',
        },
        disabled: {
            button: '#9fa1a3',
        },
        border: {
            textField: '#0000003b',
        },
        boxShadow: {
            light: '0px 2px 10px 0px rgba(0, 0, 0, 0.05)',
            main:
                '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 1px 1px -1px rgba(0,0,0,0.12)',
            dark:
                '0 8px 28px -12px rgba(0, 0, 0, 0.56), 0 4px 15px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
        },
        chat: {
            button: '#2fbcc5',
            receiverBubble: '#99dab1',
            senderBubble: '##def3fc',
        },
    },

    typography: {
        useNextVariants: true,
        fontFamily: 'lato,sans-serif',
        color: {
            light: '#ffffff',
            secondaryLight: '#F4F5F9',
            darkBlue: '#25406B',
            gray: '#9fa1a3',
            lightGray: '#858686',
            main: '#0000008a',
            dark: '#000000',
            error: '#f44336',
        },
    },
});


const { persistor, store } = configureStore();
const RootProvider = () => {
    return (
        <BrowserRouter>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ThemeProvider theme={theme}>
                        <RootRouter />
                    </ThemeProvider>
                </PersistGate>
            </Provider>
        </BrowserRouter>
    );
}

export default RootProvider;